import React, { useState } from "react";
import { Mail, Phone, CalendarClock, Trash2, Check, Plus, Loader2 } from "lucide-react";
import { toast } from "sonner";
import * as api from "../api";

export const MEMO_TIPI = [
  ["mail", "Invio mail", Mail],
  ["telefono", "Telefonare", Phone],
  ["appuntamento", "Appuntamento", CalendarClock],
];
export const memoIcona = (tipo) => (MEMO_TIPI.find(([t]) => t === tipo) || MEMO_TIPI[2])[2];
export const memoLabel = (tipo) => (MEMO_TIPI.find(([t]) => t === tipo) || MEMO_TIPI[2])[1];
export const isoGiorno = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

// Memo di un giorno del calendario: elenco + nuovo memo (tipo, account, ora, testo)
export default function MemoGiorno({ giorno, memo, accounts, onChange }) {
  const [tipo, setTipo] = useState("appuntamento");
  const [accountId, setAccountId] = useState("");
  const [ora, setOra] = useState("");
  const [testo, setTesto] = useState("");
  const [busy, setBusy] = useState(false);
  const iso = isoGiorno(giorno);
  const passato = iso < isoGiorno(new Date());
  const lista = memo.filter((m) => m.data === iso);

  const salva = async () => {
    if (!testo.trim()) return toast.error("Scrivi il testo del memo");
    setBusy(true);
    try {
      await api.addMemo({ data: iso, tipo, testo: testo.trim(), ora, account_id: accountId });
      setTesto(""); setOra("");
      toast.success("Memo salvato: te lo ricordo quel giorno all'apertura e con una notifica");
      onChange();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Salvataggio non riuscito");
    } finally { setBusy(false); }
  };
  const fatto = (m) => api.setMemoFatto(m.id, !m.fatto).then(onChange).catch(() => toast.error("Aggiornamento non riuscito"));
  const elimina = (m) => api.deleteMemo(m.id).then(onChange).catch(() => toast.error("Eliminazione non riuscita"));

  return (
    <div className="memo-box" data-testid="memo-giorno">
      <div className="calendario-lista-title">Memo · {lista.length}</div>
      {lista.map((m) => {
        const Icon = memoIcona(m.tipo);
        return (
          <div key={m.id} className={`memo-item ${m.fatto ? "fatto" : ""}`} data-testid={`memo-item-${m.id}`}>
            <span className="cal-dot" style={{ background: m.colore || "#122a44" }} />
            <Icon size={16} strokeWidth={2.4} />
            <span className="memo-ora">{m.ora || "—"}</span>
            <span className="memo-testo">{m.testo}{m.account_label ? <em> · {m.account_label}</em> : null}</span>
            <button className="icon-plain" title={m.fatto ? "Segna da fare" : "Segna fatto"} onClick={() => fatto(m)} data-testid={`memo-fatto-${m.id}`}><Check size={16} /></button>
            <button className="icon-plain" title="Elimina" onClick={() => elimina(m)} data-testid={`memo-del-${m.id}`}><Trash2 size={16} /></button>
          </div>
        );
      })}
      {!passato && (
        <div className="memo-form" data-testid="memo-form">
          <div className="proto-row">
            {MEMO_TIPI.map(([t, l, Icon]) => (
              <button key={t} type="button" className={`wf-btn proto-btn ${tipo === t ? "primary" : ""}`} onClick={() => setTipo(t)} data-testid={`memo-tipo-${t}`}><Icon size={14} /> {l}</button>
            ))}
          </div>
          <div className="host-port">
            <select className="wf-input" value={accountId} onChange={(e) => setAccountId(e.target.value)} data-testid="memo-account">
              <option value="">Account (facoltativo)</option>
              {accounts.map((a) => <option key={a.id} value={a.id}>{a.label || a.email}</option>)}
            </select>
            <input className="wf-input" type="time" value={ora} onChange={(e) => setOra(e.target.value)} data-testid="memo-ora" />
          </div>
          <div className="host-port memo-row">
            <input className="wf-input" placeholder="Es. chiamare il fornitore per il preventivo" value={testo} onChange={(e) => setTesto(e.target.value)} onKeyDown={(e) => e.key === "Enter" && salva()} data-testid="memo-testo" />
            <button className="wf-btn primary" onClick={salva} disabled={busy} data-testid="memo-save">{busy ? <Loader2 size={16} className="spin-icon" /> : <Plus size={16} />} Memo</button>
          </div>
        </div>
      )}
    </div>
  );
}
